import { type ReactElement } from 'react';
import type { Getter } from '@tanstack/react-table';

import { DateCell } from '@crossnokaye/ux-common';

import { formatFacilityDateAtTime } from '@/helpers/datetime/facility-date';

/**
 * TZDateCell
 *
 * A wrapper around DateCell that applies timezone-aware date formatting.
 * Uses a custom dateFormatter from column meta if provided, otherwise defaults to formatDateCellFormatter.
 *
 * @param props - Cell context from TanStack Table
 * @returns ReactElement
 */
export const TZDateCell = <TValue,>({ getValue }: { getValue: Getter<TValue> }): ReactElement => {
  return (
    <DateCell getValue={getValue as Getter<TValue>} dateFormatter={formatFacilityDateAtTime} />
  );
};
